import { render, staticRenderFns } from "./LotteryResultPopup.vue?vue&type=template&id=17b0348e&scoped=true"
import script from "./LotteryResultPopup.vue?vue&type=script&lang=js"
export * from "./LotteryResultPopup.vue?vue&type=script&lang=js"
import style0 from "./LotteryResultPopup.vue?vue&type=style&index=0&id=17b0348e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0348e",
  null
  
)

export default component.exports